export default __webpack_public_path__ + "7ad4298b961a0ae760acc372c9579ec7.png";